import utils from './utils';

const useNewMarathonApi = typeof window !== 'undefined' && window.MARATHON_USE_NEW_API && window.MARATHON_API_BASE;
const baseUrl = useNewMarathonApi ? window.MARATHON_API_BASE : (typeof BASE_API_URL !== 'undefined' ? BASE_API_URL : '');
const marathonsPath = baseUrl + (useNewMarathonApi ? '/marathons' : '/marathons');

// Authenticated "my marathons" (frontend integration checklist):
// - utils.get() uses getFetchParams() which sets credentials: 'include' → session cookie is sent.
// - Portal shim (marathon/api_views/common.py) sees session user and adds Authorization: Bearer <JWT>
//   when forwarding to marathon service, so the new service receives a valid token.
export default {
    getLanguages: () => useNewMarathonApi
        ? utils.get(`${window.MARATHON_API_BASE}/marathons/languages`)
        : utils.get(`${marathonsPath}/languages.json`),
    getReviews: () => useNewMarathonApi
        ? utils.get(`${window.MARATHON_API_BASE}/reviews`)
        : utils.get(`${marathonsPath}/reviews.json`),
    register: data => useNewMarathonApi
        ? utils.post(`${window.MARATHON_API_BASE}/registrations`, data)
        : utils.post(`${marathonsPath}/register.json`, data),
    getMyMarathons: () => useNewMarathonApi
        ? utils.get(`${window.MARATHON_API_BASE}/me/marathons`)
        : utils.get(`${marathonsPath}/my.json`),
    getMyMarathon: (id) => useNewMarathonApi
        ? utils.get(`${window.MARATHON_API_BASE}/me/marathons/${id}`)
        : utils.get(`${marathonsPath}/my/${id}.json`),
}



// WEBPACK FOOTER //
// ./src/api/marathons.js